import React from 'react'
import { Image, Box, FlexColumn, SideNav, SideNavLink } from 'elements'
import logo from 'theme/images/scrutinize-logo-256x256.png'
import { useDecision } from '@optimizely/react-sdk'
import { useAuth } from 'hooks'

export const NAV_BAR_WIDTH = 70

const OrgNavLink = ({ path, organization, ...props }) => {
  if (!organization) {
    return null
  }

  return <SideNavLink to={`/orgs/${organization.slug}/${path}`} {...props} />
}

const CompanyNavLink = ({ company, path, ...props }) => {
  if (!company) {
    return null
  }

  return <OrgNavLink path={`companies/${company.id}/${path}`} {...props} />
}

export default function NavBar() {
  const [decision] = useDecision('canManageCompany')
  const manageCompanyEnabled = decision.enabled

  const { currentCompany, currentOrg } = useAuth()

  return (
    <SideNav
      bg="nav.default"
      boxShadow="0px 45px 80px rgba(0, 0, 0, .1), 0px 6px 10px rgba(0, 0, 0, .1)"
      position="fixed"
      top="0"
      bottom="0"
      width={`${NAV_BAR_WIDTH}px`}
    >
      <Box>
        <FlexColumn
          height="70px"
          // borderBottom="2px solid rgba(255, 255, 255, 0.1)"
          mb="xxlarge"
          justifyContent="center"
          p="small"
        >
          <Image src={logo} width="100%" />
        </FlexColumn>
        <OrgNavLink
          exact
          path="companies"
          organization={currentOrg}
          icon="home"
          label="Companies"
        />
        <CompanyNavLink
          company={currentCompany}
          path="reports"
          organization={currentOrg}
          icon="document-report"
          label="Reports"
        />
        {manageCompanyEnabled ? (
          <CompanyNavLink
            company={currentCompany}
            path="details"
            organization={currentOrg}
            icon="globe-alt"
            label="Company"
          />
        ) : null}
        <CompanyNavLink
          company={currentCompany}
          path="integrations"
          organization={currentOrg}
          icon="database"
          label="Integrations"
        />
        <OrgNavLink organization={currentOrg} path="templates" icon="adjustments" />
      </Box>
    </SideNav>
  )
}
